import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../../ui/dialog";
import { api, errMsg } from "../../../lib/api";

const field = "w-full h-10 px-3 rounded-xl bg-slate-50 border border-slate-200 text-sm text-slate-900 outline-none focus:border-sky-400 focus:bg-white";
const today = () => new Date().toISOString().slice(0, 10);

export const TopupDialog = ({ open, base, onClose, onDone }) => {
  const [f, setF] = useState({ credits: 100, inr: "", paid_on: today(), note: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF({ credits: 100, inr: "", paid_on: today(), note: "" }); }, [open]);
  const set = (u) => setF((x) => ({ ...x, ...u }));
  const suggested = Math.round(Number(f.credits || 0) * (base || 0));

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.adminAddTopup({ credits: Number(f.credits), amount_inr: f.inr === "" ? suggested : Number(f.inr), paid_on: f.paid_on, note: f.note || undefined });
      toast.success(`Recorded ${f.credits} Emergent credits`); onDone(); onClose();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md bg-white border-slate-200" data-testid="topup-dialog">
        <DialogTitle className="text-slate-900">Record an Emergent top-up</DialogTitle>
        <DialogDescription className="text-sm text-slate-500">Log the credits you bought on Emergent so you can see how much is left for your merchants' builds.</DialogDescription>
        <form onSubmit={submit} className="grid grid-cols-2 gap-3">
          <label className="text-xs text-slate-500 space-y-1.5 block">Credits bought
            <input type="number" min={1} required value={f.credits} onChange={(e) => set({ credits: e.target.value })} data-testid="topup-credits" className={`${field} font-mono`} /></label>
          <label className="text-xs text-slate-500 space-y-1.5 block">You paid (₹)
            <input type="number" min={0} step="0.01" value={f.inr} placeholder={String(suggested)} onChange={(e) => set({ inr: e.target.value })} data-testid="topup-inr" className={`${field} font-mono`} /></label>
          <label className="col-span-2 text-xs text-slate-500 space-y-1.5 block">Date
            <input type="date" value={f.paid_on} max={today()} onChange={(e) => set({ paid_on: e.target.value })} data-testid="topup-date" className={field} /></label>
          <input value={f.note} onChange={(e) => set({ note: e.target.value })} maxLength={200} placeholder="Note (optional)" data-testid="topup-note" className={`${field} col-span-2`} />
          <button type="submit" disabled={busy || Number(f.credits) < 1} data-testid="topup-submit"
            className="col-span-2 h-11 rounded-full bg-slate-900 text-white text-sm font-semibold flex items-center justify-center gap-2 hover:bg-slate-700 disabled:opacity-50">
            {busy && <Loader2 size={15} className="animate-spin" />} Save top-up
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default TopupDialog;
